import React from 'react';

interface CarouselSkeletonProps {
  title?: string;
}

export const CarouselSkeleton: React.FC<CarouselSkeletonProps> = ({ title }) => {
  return (
    <div className="mb-8">
      <div className="flex items-center justify-between mb-4 px-6">
        {title ? (
          <h2 className="text-xl font-semibold text-gray-900">{title}</h2>
        ) : (
          <div className="h-7 w-48 bg-gray-200 rounded animate-pulse" />
        )}
      </div>
      
      <div className="flex gap-4 overflow-x-auto pb-4 scrollbar-hide px-6">
        {[...Array(4)].map((_, index) => (
          <div key={index} className="flex-shrink-0 w-[280px]">
            <div className="rounded-xl overflow-hidden">
              <div className="aspect-[4/3] bg-gray-200 animate-pulse" />
              <div className="pt-3 space-y-2">
                <div className="h-5 w-3/4 bg-gray-200 rounded animate-pulse" />
                <div className="h-4 w-1/2 bg-gray-100 rounded animate-pulse" />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CarouselSkeleton;
